// Notification API client

import axios from '@/api/axios'

export interface NotificationResponse {
  id: number
  user_id: number
  type: string
  title: string
  message: string
  data: Record<string, any> | null
  is_read: boolean
  read_at: string | null
  created_at: string
}

export interface CommentResponse {
  id: number
  lead_id: number
  user_id: number
  content: string
  is_internal: boolean
  created_at: string
  updated_at: string | null
  user?: {
    id: number
    first_name: string | null
    last_name: string | null
    full_name: string | null
  }
}

export interface CommentCreate {
  content: string
  is_internal: boolean
}

export const notificationApi = {
  // Notifications
  getNotifications: async (unreadOnly = false, limit = 50): Promise<NotificationResponse[]> => {
    const { data } = await axios.get('/api/v1/notifications/my', {
      params: { unread_only: unreadOnly, limit },
    })
    return data
  },

  getUnreadCount: async (): Promise<{ count: number }> => {
    const { data } = await axios.get('/api/v1/notifications/my/unread-count')
    return data
  },

  markAsRead: async (notificationId: number): Promise<void> => {
    await axios.post(`/api/v1/notifications/${notificationId}/mark-read`)
  },

  markAllAsRead: async (): Promise<void> => {
    await axios.post('/api/v1/notifications/my/mark-all-read')
  },

  // Comments
  getLeadComments: async (leadId: number, includeInternal = true): Promise<CommentResponse[]> => {
    const { data } = await axios.get(`/api/v1/notifications/leads/${leadId}/comments`, {
      params: { include_internal: includeInternal },
    })
    return data
  },

  createComment: async (leadId: number, content: string, isInternal = false): Promise<CommentResponse> => {
    const { data } = await axios.post(`/api/v1/notifications/leads/${leadId}/comments`, {
      content,
      is_internal: isInternal,
    })
    return data
  },

  updateComment: async (commentId: number, content: string): Promise<CommentResponse> => {
    const { data } = await axios.put(`/api/v1/notifications/comments/${commentId}`, {
      content,
    })
    return data
  },

  deleteComment: async (commentId: number): Promise<void> => {
    await axios.delete(`/api/v1/notifications/comments/${commentId}`)
  },
}